(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lunarae-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lunarae-shop-the-look')) {
    class LunaraeShopTheLook extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.addBothButton = this.querySelector('[data-add-both]');
        this.errorElement = this.querySelector('[data-add-both-error]');

        this.addBothButton?.addEventListener('click', this.addBoth.bind(this), {
          signal: this.abortController.signal
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      async addBoth() {
        if (!this.addBothButton || this.addBothButton.getAttribute('aria-busy') === 'true') return;

        const variantIds = [this.dataset.variantOne, this.dataset.variantTwo];

        if (variantIds.some((variantId) => !/^\d+$/.test(variantId || ''))) {
          this.showError('Choose options for both products before adding the look.');
          return;
        }

        this.errorElement.hidden = true;
        this.addBothButton.disabled = true;
        this.addBothButton.setAttribute('aria-busy', 'true');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        try {
          const sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle }
            })
          );

          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: variantIds.map((id) => ({ id, quantity: 1 })),
              sections: [...new Set(sectionsToBundle)].join(','),
              sections_url: window.location.pathname
            })
          });

          const responseJson = await response.json();

          if (!response.ok) {
            throw new Error(responseJson.description || responseJson.message || 'The look could not be added.');
          }

          if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
            window.location.href = `${root}cart`;
            return;
          }

          const cartResponse = await fetch(`${root}cart.js`);

          if (!cartResponse.ok) {
            throw new Error('The cart could not be refreshed.');
          }

          const cart = await cartResponse.json();
          cart.sections = responseJson.sections || {};

          this.dispatchEvent(
            new CustomEvent('variant:add', {
              bubbles: true,
              detail: {
                items: responseJson.items || [],
                cart,
                onSuccessDo: 'force_open_drawer'
              }
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                onSuccessDo: 'force_open_drawer',
                cart
              }
            })
          );
        } catch (error) {
          this.showError(error.message || 'The look could not be added. Please try again.');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } finally {
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          this.addBothButton.removeAttribute('aria-busy');
          this.addBothButton.disabled = false;
        }
      }

      showError(message) {
        if (!this.errorElement) return;

        this.errorElement.textContent = message;
        this.errorElement.hidden = false;
      }
    }

    customElements.define('lunarae-shop-the-look', LunaraeShopTheLook);
  }

  } catch(e) { console.error(e); }
})();
})();
